import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { offerIncludes } from '../data/strategy';
export function OfferSection() {
  return <section id="acceso" className="border-b border-line" data-id="element-37" data-mp="3m96poi3qqeg">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-20 lg:px-10 lg:py-28" data-id="element-38" data-mp="8mdoriynrt6s">
        <div className="mx-auto max-w-4xl overflow-hidden rounded-lg border border-white/10 bg-ink-800" data-id="element-39" data-mp="dend4uk4kl6y">
          <div className="grid md:grid-cols-5" data-id="element-40" data-mp="idzvb201x437">
            <div className="border-b border-line p-8 md:col-span-3 md:border-b-0 md:border-r md:p-10" data-id="element-41" data-mp="ifayp0pl49ts">
              <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-cyan-vip" data-id="element-42" data-mp="mgwhf2osvibw">
                Acceso VIP
              </span>
              <h2 className="mt-4 text-2xl font-semibold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-43" data-mp="wd9f0bngugbx">
                Manual Protocolo de Apertura VIP
              </h2>
              <p className="mt-3 text-[14px] leading-relaxed text-white/50" data-id="element-44" data-mp="2y44a119umbhl">
                Todo el sistema documentado paso a paso, con las herramientas
                para ejecutarlo desde la primera sesión.
              </p>

              <ul className="mt-8 space-y-3" data-id="element-45" data-mp="xvqt9tmv54cb">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-46" data-mp="syqn7iq0k1l7">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-vip" aria-hidden="true" data-id="element-47" data-mp="owdkz4ah6lt6" />
                    <span className="text-[14px] text-white/75" data-id="element-48" data-mp="1lka2qchnfn5z">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-between p-8 md:col-span-2 md:p-10" data-id="element-49" data-mp="1ckwrbe9ysoim">
              <div data-id="element-50" data-mp="17n4qfurcds2a">
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/35" data-id="element-51" data-mp="17ljwa68xwb4y">
                  Pago único
                </span>
                <p className="mt-3 flex items-baseline gap-2" data-id="element-52" data-mp="146jjqpw7omw">
                  <span className="text-4xl font-semibold tracking-tight text-white" data-id="element-53" data-mp="3sb98scm67kuh">
                    6.990
                  </span>
                  <span className="font-mono text-[13px] text-white/40" data-id="element-54" data-mp="2nol7w6cojoy">
                    CLP
                  </span>
                </p>
              </div>

              <div className="mt-10" data-id="element-55" data-mp="3ksru7rzftfun">
                <a href="https://hotmart.com" target="_blank" rel="noopener noreferrer" className="group inline-flex w-full items-center justify-center gap-2 rounded-md bg-cyan-vip px-5 py-3.5 text-center text-[14px] font-semibold tracking-tight text-ink shadow-glow transition-[box-shadow,transform,background-color] duration-150 ease-out hover:shadow-glow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-vip focus-visible:ring-offset-2 focus-visible:ring-offset-ink-800 active:translate-y-px" data-id="element-56" data-mp="3ouwmama8m4f6">
                  Obtener Acceso Inmediato en Hotmart
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-57" data-mp="2x2xjbfyoi1d1" />
                </a>
                <p className="mt-3 text-center font-mono text-[11px] text-white/30" data-id="element-58" data-mp="28l6xsr5g728a">
                  Entrega inmediata · Pago seguro vía Hotmart
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}